// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.RecommendedVenuesCard_recommendedVenuesCard__Vhm4w {
  background: var(--white);
  border-radius: 12px;
  padding: 4px;
  display: flex;
  align-items: stretch;
  justify-content: start;
  flex-wrap: nowrap;
  gap: 7px;
  width: 100%;
  flex: 0 0 auto;
}
@media (max-width: 599px) {
  .RecommendedVenuesCard_recommendedVenuesCard__Vhm4w {
    flex-wrap: wrap;
  }
}
.RecommendedVenuesCard_recommendedVenuesCard__Vhm4w .RecommendedVenuesCard_recommendedVenuesImage__JkBLD {
  border-radius: 12px;
  aspect-ratio: 179/123;
  max-width: 179px;
  width: 100%;
  overflow: hidden;
}
@media (max-width: 450px) {
  .RecommendedVenuesCard_recommendedVenuesCard__Vhm4w .RecommendedVenuesCard_recommendedVenuesImage__JkBLD {
    max-width: 100%;
  }
}
.RecommendedVenuesCard_recommendedVenuesCard__Vhm4w .RecommendedVenuesCard_recommendedVenuesImage__JkBLD img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.RecommendedVenuesCard_recommendedVenuesCard__Vhm4w .RecommendedVenuesCard_recommendedVenuesContents__ujrLm {
  width: 40%;
  padding: 10px 0;
}
@media (max-width: 599px) {
  .RecommendedVenuesCard_recommendedVenuesCard__Vhm4w .RecommendedVenuesCard_recommendedVenuesContents__ujrLm {
    width: calc(100% - 7px - 179px);
  }
}
@media (max-width: 450px) {
  .RecommendedVenuesCard_recommendedVenuesCard__Vhm4w .RecommendedVenuesCard_recommendedVenuesContents__ujrLm {
    width: 100%;
  }
}
.RecommendedVenuesCard_recommendedVenuesCard__Vhm4w .RecommendedVenuesCard_recommendedVenuesContents__ujrLm h4 {
  font: var(--body-font-one);
  color: var(--primary-Text);
  font-weight: 700;
}
.RecommendedVenuesCard_recommendedVenuesCard__Vhm4w .RecommendedVenuesCard_recommendedVenuesContents__ujrLm .RecommendedVenuesCard_recommendedVenuesContentText__Wjhd3 {
  margin-top: 7px;
}
.RecommendedVenuesCard_recommendedVenuesCard__Vhm4w .RecommendedVenuesCard_recommendedVenuesContents__ujrLm .RecommendedVenuesCard_recommendedVenuesContentText__Wjhd3 p {
  display: flex;
  justify-content: start;
  align-items: center;
  gap: 5px;
  color: var(--primary-Text);
  font: var(--body-font-four);
  margin-top: 4px;
}
.RecommendedVenuesCard_recommendedVenuesCard__Vhm4w .RecommendedVenuesCard_recommendedVenuesContents__ujrLm .RecommendedVenuesCard_recommendedVenuesContentText__Wjhd3 p:first-child {
  margin-top: 0;
}
.RecommendedVenuesCard_recommendedVenuesCard__Vhm4w .RecommendedVenuesCard_recommendedVenuesContents__ujrLm .RecommendedVenuesCard_recommendedVenuesContentText__Wjhd3 p img {
  width: 16px;
  height: 16px;
}
.RecommendedVenuesCard_recommendedVenuesCard__Vhm4w .RecommendedVenuesCard_recommendedVenuesContent__1QV\\+M {
  display: flex;
  justify-content: space-between;
  align-items: end;
  flex-direction: column;
  gap: 10px;
  height: auto;
  padding: 10px 0;
  padding-left: 20px;
  border-left: 2px solid #d3dae0;
  width: 70%;
}
@media (max-width: 599px) {
  .RecommendedVenuesCard_recommendedVenuesCard__Vhm4w .RecommendedVenuesCard_recommendedVenuesContent__1QV\\+M {
    width: 100%;
    padding: 0;
    border-left: 0;
  }
}
.RecommendedVenuesCard_recommendedVenuesCard__Vhm4w .RecommendedVenuesCard_recommendedVenuesContent__1QV\\+M .RecommendedVenuesCard_recommendedVenuesCapacityTag__3Iclu {
  width: 100%;
}
.RecommendedVenuesCard_recommendedVenuesCard__Vhm4w .RecommendedVenuesCard_recommendedVenuesContent__1QV\\+M .RecommendedVenuesCard_recommendedVenuesCapacityTag__3Iclu p {
  display: flex;
  justify-content: start;
  align-items: center;
  gap: 5px;
  padding: 2px 6px;
  background-color: #e5ffe3;
  border-radius: 500px;
  width: fit-content;
  color: #022a4f;
  font: var(--body-font-four);
  font-weight: 700;
}
.RecommendedVenuesCard_recommendedVenuesCard__Vhm4w .RecommendedVenuesCard_recommendedVenuesContent__1QV\\+M .RecommendedVenuesCard_recommendedVenuesCapacityTag__3Iclu p span {
  color: #323539;
  font-weight: 400;
}
.RecommendedVenuesCard_recommendedVenuesCard__Vhm4w .RecommendedVenuesCard_recommendedVenuesContent__1QV\\+M .RecommendedVenuesCard_recommendedVenuesCapacityTag__3Iclu p img {
  width: 16px;
  height: 16px;
}
.RecommendedVenuesCard_recommendedVenuesCard__Vhm4w .RecommendedVenuesCard_recommendedVenuesContent__1QV\\+M .RecommendedVenuesCard_recommendedVenuesContentTag__Kl6T9 {
  display: flex;
  justify-content: start;
  align-items: center;
  gap: 8px;
  width: 100%;
}
.RecommendedVenuesCard_recommendedVenuesCard__Vhm4w .RecommendedVenuesCard_recommendedVenuesContent__1QV\\+M .RecommendedVenuesCard_recommendedVenuesContentTag__Kl6T9 p {
  display: flex;
  justify-content: start;
  align-items: center;
  gap: 5px;
  padding: 4px 10px;
  background-color: #eff6fa;
  border-radius: 500px;
  width: fit-content;
  color: #6b7280;
  font: var(--body-font-three);
  font-weight: 500;
}
.RecommendedVenuesCard_recommendedVenuesCard__Vhm4w .RecommendedVenuesCard_recommendedVenuesContent__1QV\\+M .RecommendedVenuesCard_recommendedVenuesContentTag__Kl6T9 p img {
  width: 16px;
  height: 16px;
}`, "",{"version":3,"sources":["webpack://./src/components/UserDashboard/RecommendedVenues/RecommendedVenuesCard.module.scss"],"names":[],"mappings":"AAAA;EACC,wBAAA;EACA,mBAAA;EACA,YAAA;EACA,aAAA;EACA,oBAAA;EACA,sBAAA;EACA,iBAAA;EACA,QAAA;EACA,WAAA;EACA,cAAA;AACD;AACC;EAZD;IAaE,eAAA;EAEA;AACF;AAAC;EACC,mBAAA;EACA,qBAAA;EACA,gBAAA;EACA,WAAA;EACA,gBAAA;AAEF;AAAE;EAPD;IAQE,eAAA;EAGD;AACF;AADE;EACC,WAAA;EACA,YAAA;EACA,iBAAA;AAGH;AACC;EACC,UAAA;EACA,eAAA;AACF;AACE;EAJD;IAKE,+BAAA;EAED;AACF;AAAE;EARD;IASE,WAAA;EAGD;AACF;AADE;EACC,0BAAA;EACA,0BAAA;EACA,gBAAA;AAGH;AAAE;EACC,eAAA;AAEH;AAAG;EACC,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,QAAA;EAEA,0BAAA;EACA,2BAAA;EAEA,eAAA;AAAJ;AAEI;EACC,aAAA;AAAL;AAGI;EACC,WAAA;EACA,YAAA;AADL;AAOC;EACC,aAAA;EACA,8BAAA;EACA,gBAAA;EACA,sBAAA;EACA,SAAA;EACA,YAAA;EACA,eAAA;EACA,kBAAA;EACA,8BAAA;EACA,UAAA;AALF;AAOE;EAZD;IAaE,WAAA;IACA,UAAA;IACA,cAAA;EAJD;AACF;AAME;EACC,WAAA;AAJH;AAMG;EACC,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,QAAA;EACA,gBAAA;EACA,yBAAA;EACA,oBAAA;EACA,kBAAA;EACA,cAAA;EACA,2BAAA;EACA,gBAAA;AAJJ;AAMI;EACC,cAAA;EACA,gBAAA;AAJL;AAOI;EACC,WAAA;EACA,YAAA;AALL;AAUE;EACC,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,QAAA;EACA,WAAA;AARH;AAUG;EACC,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,QAAA;EACA,iBAAA;EACA,yBAAA;EACA,oBAAA;EACA,kBAAA;EACA,cAAA;EACA,4BAAA;EACA,gBAAA;AARJ;AAUI;EACC,WAAA;EACA,YAAA;AARL","sourcesContent":[".recommendedVenuesCard {\r\n\tbackground: var(--white);\r\n\tborder-radius: 12px;\r\n\tpadding: 4px;\r\n\tdisplay: flex;\r\n\talign-items: stretch;\r\n\tjustify-content: start;\r\n\tflex-wrap: nowrap;\r\n\tgap: 7px;\r\n\twidth: 100%;\r\n\tflex: 0 0 auto;\r\n\r\n\t@media (max-width: 599px) {\r\n\t\tflex-wrap: wrap;\r\n\t}\r\n\r\n\t.recommendedVenuesImage {\r\n\t\tborder-radius: 12px;\r\n\t\taspect-ratio: 179 / 123;\r\n\t\tmax-width: 179px;\r\n\t\twidth: 100%;\r\n\t\toverflow: hidden;\r\n\r\n\t\t@media (max-width: 450px) {\r\n\t\t\tmax-width: calc(100%);\r\n\t\t}\r\n\r\n\t\timg {\r\n\t\t\twidth: 100%;\r\n\t\t\theight: 100%;\r\n\t\t\tobject-fit: cover;\r\n\t\t}\r\n\t}\r\n\r\n\t.recommendedVenuesContents {\r\n\t\twidth: 40%;\r\n\t\tpadding: 10px 0;\r\n\r\n\t\t@media (max-width: 599px) {\r\n\t\t\twidth: calc(100% - 7px - 179px);\r\n\t\t}\r\n\r\n\t\t@media (max-width: 450px) {\r\n\t\t\twidth: calc(100%);\r\n\t\t}\r\n\r\n\t\th4 {\r\n\t\t\tfont: var(--body-font-one);\r\n\t\t\tcolor: var(--primary-Text);\r\n\t\t\tfont-weight: 700;\r\n\t\t}\r\n\r\n\t\t.recommendedVenuesContentText {\r\n\t\t\tmargin-top: 7px;\r\n\r\n\t\t\tp {\r\n\t\t\t\tdisplay: flex;\r\n\t\t\t\tjustify-content: start;\r\n\t\t\t\talign-items: center;\r\n\t\t\t\tgap: 5px;\r\n\r\n\t\t\t\tcolor: var(--primary-Text);\r\n\t\t\t\tfont: var(--body-font-four);\r\n\r\n\t\t\t\tmargin-top: 4px;\r\n\r\n\t\t\t\t&:first-child {\r\n\t\t\t\t\tmargin-top: 0;\r\n\t\t\t\t}\r\n\r\n\t\t\t\timg {\r\n\t\t\t\t\twidth: 16px;\r\n\t\t\t\t\theight: 16px;\r\n\t\t\t\t}\r\n\t\t\t}\r\n\t\t}\r\n\t}\r\n\r\n\t.recommendedVenuesContent {\r\n\t\tdisplay: flex;\r\n\t\tjustify-content: space-between;\r\n\t\talign-items: end;\r\n\t\tflex-direction: column;\r\n\t\tgap: 10px;\r\n\t\theight: auto;\r\n\t\tpadding: 10px 0;\r\n\t\tpadding-left: 20px;\r\n\t\tborder-left: 2px solid #d3dae0;\r\n\t\twidth: 70%;\r\n\r\n\t\t@media (max-width: 599px) {\r\n\t\t\twidth: calc(100%);\r\n\t\t\tpadding: 0;\r\n\t\t\tborder-left: 0;\r\n\t\t}\r\n\r\n\t\t.recommendedVenuesCapacityTag {\r\n\t\t\twidth: 100%;\r\n\r\n\t\t\tp {\r\n\t\t\t\tdisplay: flex;\r\n\t\t\t\tjustify-content: start;\r\n\t\t\t\talign-items: center;\r\n\t\t\t\tgap: 5px;\r\n\t\t\t\tpadding: 2px 6px;\r\n\t\t\t\tbackground-color: #e5ffe3;\r\n\t\t\t\tborder-radius: 500px;\r\n\t\t\t\twidth: fit-content;\r\n\t\t\t\tcolor: #022a4f;\r\n\t\t\t\tfont: var(--body-font-four);\r\n\t\t\t\tfont-weight: 700;\r\n\r\n\t\t\t\tspan {\r\n\t\t\t\t\tcolor: #323539;\r\n\t\t\t\t\tfont-weight: 400;\r\n\t\t\t\t}\r\n\r\n\t\t\t\timg {\r\n\t\t\t\t\twidth: 16px;\r\n\t\t\t\t\theight: 16px;\r\n\t\t\t\t}\r\n\t\t\t}\r\n\t\t}\r\n\r\n\t\t.recommendedVenuesContentTag {\r\n\t\t\tdisplay: flex;\r\n\t\t\tjustify-content: start;\r\n\t\t\talign-items: center;\r\n\t\t\tgap: 8px;\r\n\t\t\twidth: 100%;\r\n\r\n\t\t\tp {\r\n\t\t\t\tdisplay: flex;\r\n\t\t\t\tjustify-content: start;\r\n\t\t\t\talign-items: center;\r\n\t\t\t\tgap: 5px;\r\n\t\t\t\tpadding: 4px 10px;\r\n\t\t\t\tbackground-color: #eff6fa;\r\n\t\t\t\tborder-radius: 500px;\r\n\t\t\t\twidth: fit-content;\r\n\t\t\t\tcolor: #6b7280;\r\n\t\t\t\tfont: var(--body-font-three);\r\n\t\t\t\tfont-weight: 500;\r\n\r\n\t\t\t\timg {\r\n\t\t\t\t\twidth: 16px;\r\n\t\t\t\t\theight: 16px;\r\n\t\t\t\t}\r\n\t\t\t}\r\n\t\t}\r\n\t}\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"recommendedVenuesCard": `RecommendedVenuesCard_recommendedVenuesCard__Vhm4w`,
	"recommendedVenuesImage": `RecommendedVenuesCard_recommendedVenuesImage__JkBLD`,
	"recommendedVenuesContents": `RecommendedVenuesCard_recommendedVenuesContents__ujrLm`,
	"recommendedVenuesContentText": `RecommendedVenuesCard_recommendedVenuesContentText__Wjhd3`,
	"recommendedVenuesContent": `RecommendedVenuesCard_recommendedVenuesContent__1QV+M`,
	"recommendedVenuesCapacityTag": `RecommendedVenuesCard_recommendedVenuesCapacityTag__3Iclu`,
	"recommendedVenuesContentTag": `RecommendedVenuesCard_recommendedVenuesContentTag__Kl6T9`
};
export default ___CSS_LOADER_EXPORT___;
